import { Button, message, Form, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import 'assets/styles/Profile.scss';
import { Input } from 'antd';
import { useTranslation } from 'react-i18next';

import cameraIcon from 'assets/images/camera.png';
import NoAvatar from 'assets/images/no-avatar.png';

//requests
import { changePassword } from 'requests/profile';
import { updateProfileAction as updateProfile } from 'redux/actions/auth';
import { useEffect } from 'react';

const ProfilePage = () => {
    const { t } = useTranslation();
    const authUser = useSelector((state) => state.auth.authUser);
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const navigate = useNavigate();

    useEffect(() => {
        return () => {
            sessionStorage.setItem('is_form_changed', 0);
        };
    }, []);

    const showEditConfirm = () => {
        onEditProfile(authUser.id);
    };

    const onEditProfile = async (id) => {
        try {
            const values = await form.validateFields();
            for (const key in values) {
                if (typeof values[key] === 'string') values[key] = values[key].trim();
            }
            form.setFieldsValue(values);

            const formData = new FormData();
            formData.append('name', values.name);
            formData.append('mobile', values.mobile);

            await dispatch(updateProfile(formData));
            message.success(t('success'));
        } catch (err) {
            console.log(err);
            message.error(t(err.response?.data.message || 'error'));
        }
    };

    const onEditAvatar = async (file) => {
        try {
            const formData = new FormData();
            formData.append('avatar', file);
            await dispatch(updateProfile(formData));
            message.success(t('success'));
        } catch (err) {
            console.log(err);
            message.error(t(err.response?.data.message || 'error'));
        }
    };

    const onSubmit = async (data) => {
        try {
            if (data.new_password === data.confirm_password) {
                const payload = {
                    oldPassword: data.old_password,
                    newPassword: data.new_password,
                };
                await changePassword(payload);
                message.success(t('success'));
            } else {
                message.error(t('confirm_password_not_match'));
            }
        } catch (err) {
            console.log(err);
            message.error(t(err.response?.data.message || 'error'));
        }
    };

    return (
        <>
            <div className="account">
                <div className="account-settings">
                    <h2>{t('account_settings')}</h2>
                    <div className="account-text">
                        <div className="account-avatar-wrapper">
                            <label>
                                <input type="file" accept="image/*" onChange={(e) => onEditAvatar(e.target.files[0])} />
                                <img
                                    src={authUser.avatarUrl ? authUser.avatarUrl : NoAvatar}
                                    className="account-avatar"
                                    alt=""
                                />
                                <div className="account-avatar-icon">
                                    <img src={cameraIcon} alt="" />
                                </div>
                            </label>
                        </div>

                        <Form
                            form={form}
                            initialValues={authUser}
                            labelCol={{
                                span: 8,
                            }}
                            wrapperCol={{
                                span: 16,
                            }}
                        >
                            <Form.Item
                                name="name"
                                label={t('full_name')}
                                rules={[{ required: true, pattern: /\S+/, message: t('required_field') }]}
                            >
                                <Input placeholder="input placeholder" />
                            </Form.Item>
                            <Form.Item name="email" label={t('email')}>
                                <Input placeholder="input placeholder" disabled />
                            </Form.Item>
                            <Form.Item
                                name="mobile"
                                label={t('mobile')}
                                rules={[{ pattern: /^[\d\-+ ]+$/, message: t('phone_number_message') }]}
                            >
                                <Input placeholder={t('input_phone_add')} />
                            </Form.Item>
                        </Form>
                        <div className="add-edit-btn">
                            <Button onClick={() => navigate(-1)} className="ant-btn cancel-btn">
                                {t('cancel')}
                            </Button>
                            <Button className="ant-btn submit-btn" onClick={showEditConfirm}>
                                {t('submit')}
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="change-password">
                    <h2>{t('change_password')}</h2>
                    <div className="change-text">
                        <Card className="card-password card-border">
                            <Form
                                onFinish={onSubmit}
                                labelCol={{
                                    span: 8,
                                }}
                                wrapperCol={{
                                    span: 16,
                                }}
                            >
                                <Form.Item name="old_password" label={t('old_password')}>
                                    <Input.Password placeholder="••••••••••••••" />
                                </Form.Item>
                                <Form.Item
                                    name="new_password"
                                    label={t('new_password')}
                                    extra={t('extra_password')}
                                    rules={[
                                        {
                                            pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/,
                                            message: t('invalid_format'),
                                        },
                                    ]}
                                >
                                    <Input.Password placeholder="••••••••••••••" />
                                </Form.Item>
                                <Form.Item
                                    name="confirm_password"
                                    label={t('confirm_password')}
                                    className="password-confirm"
                                    extra={t('extra_confirm_password')}
                                >
                                    <Input.Password placeholder={t('re_enter_password')} />
                                </Form.Item>
                                <Button className="submit-btn" type="primary" htmlType="submit">
                                    {t('submit')}
                                </Button>
                            </Form>
                        </Card>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProfilePage;
